import { Action, Subject, can, cannot, createAbility } from '@/lib/permissions';

export const usePermissions = () => {
  // Admin panel always has full access - actual permissions enforced server-side
  const abilities = createAbility([{ action: 'manage', subject: 'all' }]);

  return {
    can: (action: Action, subject: Subject) => can(abilities, action, subject),
    cannot: (action: Action, subject: Subject) =>
      cannot(abilities, action, subject),
    abilities,
  };
};
